<template>
  <a-modal
    ref="refProPopup"
    title="选择商品"
    :visible="visiblePopup"
    @cancel="handleCancel"
    @ok="handleProBtns"
    width="800px"
  >
    <a-form>
      <search-header :col="2">
        <search-list>
          <a-form-item label="商品名称" v-bind="formItemLayout">
            <a-input v-model="queryParams.proName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="商品ID" v-bind="formItemLayout">
            <a-input v-model="queryParams.proId" placeholder="请输入"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="商品分类" v-bind="formItemLayout">
            <a-select
              style="width: 100%"
              v-model="queryParams.categoryId"
              placeholder="请选择" allowClear :disabled="isDisabled"
            >
              <a-select-option v-for="item in proCatalogList" :key="item.code" :value="item.code">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item v-bind="formItemLayout" style="margin-left:3%;">
            <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <div class="table-box">
      <custom-page-table
        ref="table"
        rowKey="proId"
        :columns="columns"
        :queryParams="queryParams"
        :params-path="path"
        :base-key="baseUrl"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      >
        <div slot="proSlots" slot-scope="rowItem">
          <a-tooltip placement="topLeft">
            <template slot="title">{{ rowItem.text }}</template>
            <div class="pro_name">{{ rowItem.text }}</div>
          </a-tooltip>
        </div>
        <div slot="typeSlots" slot-scope="rowItem">{{ rowItem.text | productTypeName }}</div>
      </custom-page-table>
    </div>
  </a-modal>
</template>

<script>

export default {
  name: 'homeProductView',
  props: {
    visiblePopup: {
      type: Boolean,
      default: false
    },
    catalogId: {
      type: Number,
      default: 0
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: ''
    },
    baseUrl: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      queryParams: {
        proId: '',
        proName: '',
        categoryId: this.catalogId
      },
      selectedRowKeys: [],
      proCatalogList: [],
      selectedStr: '',
      columns: [
        {
          title: 'ID',
          dataIndex: 'proId'
        },
        {
          title: '商品标题',
          dataIndex: 'proName',
          scopedSlots: { customRender: 'proSlots' }
        },
        {
          title: '商品类型',
          dataIndex: 'proCatalogId',
          scopedSlots: { customRender: 'typeSlots' },
          width: '120px'
        },
        {
          title: '状态',
          dataIndex: 'modularTitle',
          width: '120px'
        }
      ],
      hanldSales: true,
      hanldDate: true
    }
  },
  mounted() {
    this.getProCatalogList()
  },
  methods: {
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedStr = this.selectedRowKeys.join(',')
      this.getLogUtils().logWithTag('onSelectChange', this.selectedStr)
    },
    handleProBtns() {
      if (this.selectedRowKeys.length < 1) {
        this.$message.error('请选择要操作的商品')
        return
      }
      let params = new Object()
      params.proIds = this.selectedStr
      this.$emit('confirm', params)
      this.handleCancel()
      this.selectedRowKeys = []
    },
    handleCancel() {
      this.$emit('close')
    },
    getProListPromise(params) {
      this.getLogUtils().logWithTag('==getModularListPromise==', params)
      return this.getHttpServices().getUserService().post('homepage/recommend/get/modularProduct', params)
    },
    selectPro(item) {
      this.handleCancel()
      this.$emit('change', item)
    },
    getProCatalogList() {
      this.getHttpServices().getProService().get('product/info/getProCataLogId')
        .then(res => {
          this.getLogUtils().logWithTag('==getProCatalogList==', res)
          res.forEach((item) => {
            if (item.code != 83) {
              this.proCatalogList.push(item)
            }
          })
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped>
.pro_name {
  width: 100%;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.table-box {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  overflow: hidden;
}
</style>